// import { Link } from 'react-router-dom';

// material-ui
import { Grid, Typography, Box, TextField, Button, Alert } from '@mui/material';
// import Divider from 'components/misc/Divider';
import Fab from '@mui/material/Fab';
import Drawer from '@mui/material/Drawer';
import { useState, useEffect } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import CloseIcon from '@mui/icons-material/Close';
// import config from 'config';
import { authHeaders } from 'common';
import axios from 'axios';
import urls from 'backend_urls';
import { toast } from 'react-toastify';
import { Language } from 'language';

const UpdateUserDetails = (props) => {
	const [saveUserDetailsApiButton, setSaveUserDetailsApiButton] = useState(false);
	const [updatedUserData, setUpdatedUserData] = useState(props.value.value || null);
	const [updatedUserColumn, setUpdatedUserColumn] = useState(props.value.label || null);

	const [alertMessage, setAlertMessage] = useState(null);
	const anchor = 'bottom';

	const callUserDetailsSaveApi = () => {
		const fetchData = async () => {
			try {
				await axios
					.get(
						`${urls.updateUserDetails}${updatedUserColumn}/${updatedUserData}/`,
						{ headers: authHeaders() }
					)
					.then((response) => {
						toast.success(response.data.message);
						props.updateValue(updatedUserColumn, updatedUserData);
						props.setUpdateUserDetailsData(null)
						setAlertMessage(<Alert severity="success">{response.data.message}</Alert>);
					})
					.catch((error) => {
						toast.error(error.response.data.message);
						setAlertMessage(<Alert severity="error">{error.response.data.message}</Alert>);
						console.error('error', error.response.data);
					});
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};
		if (saveUserDetailsApiButton) fetchData();
	};

	const updateUserData = (label, value) => {
		if (label === Language.label.email) {
			setUpdatedUserColumn('email');
			setUpdatedUserData(value);
			var re = /\S+@\S+\.\S+/;
			let is_valid_email = re.test(value);
			if (is_valid_email) setSaveUserDetailsApiButton(true);
			else setSaveUserDetailsApiButton(false);
		}
		if (label === Language.label.name) {
			setUpdatedUserColumn('name');
			setUpdatedUserData(value);
			if (value.length > 5) setSaveUserDetailsApiButton(true);
			else setSaveUserDetailsApiButton(false);
		}
		if (label === Language.label.vehicle_number) {
			setUpdatedUserColumn('vehicle_number');
			setUpdatedUserData(value.toUpperCase());
			if (value.length > 5) setSaveUserDetailsApiButton(true);
			else setSaveUserDetailsApiButton(false);
		}
	};

	useEffect(() => {
		setUpdatedUserData(props.value.value);
	}, [props.value]);

	return (
		<>
			<Grid container>
				<Drawer anchor={anchor} open={props.open} onClose={props.toggleDrawer(false)}>
						<Grid container>
							<Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
								<HorizontalRuleIcon />
							</Grid>
							<Fab
								size="small"
								color="primary"
								aria-label="Close"
								sx={{ position: 'absolute', top: 15, right: 10 }}
								elevation={3}
								onClick={props.toggleDrawer(false)}
							>
								<CloseIcon />
							</Fab>

						</Grid>
						<Grid container>
							<Grid item xs={12} display="flex" justifyContent="center" paddingTop={2} alignItems="center">
								<Typography gutterBottom variant="h5" component="div">
									{props.value.label}
								</Typography>
							</Grid>
							<Grid item xs={12} sm={6} md={4} lg={4}>
								<Box
									component="form"
									sx={{
										'& .MuiTextField-root': { m: 1 }
									}}
									noValidate
									autoComplete="off"
									paddingBottom={4}
								>
									<>
										<TextField
											id={props.value.label}
											sx={{ width: '95%' }}
											label={props.value.label}
											variant="outlined"
											value={updatedUserData}
											onChange={(event) => {
												updateUserData(props.value.label, event.target.value);
											}}
										/>
										{alertMessage && (
											<Grid item xs={12} sx={{ paddingBottom: 1 }}>
												{alertMessage}
											</Grid>
										)}
										<Button
											disabled={!saveUserDetailsApiButton}
											onClick={callUserDetailsSaveApi}
											variant="contained"
											sx={{ width: '95%', marginLeft: '2.5%' }}
											startIcon={<SaveIcon />}
										>
											{Language.button.save}
										</Button>
									</>
								</Box>
							</Grid>
						</Grid>
				</Drawer>
			</Grid>
		</>
	);
};

export default UpdateUserDetails;
